import React from "react";
import { Link } from "react-router-dom";
import { Coins, LogIn } from "lucide-react";

// FeedPrompts — the two modal overlays that float above the player when
// the user attempts a gated action without being signed in or without
// enough credits.
//
// Rendered as a sibling fragment so callers can drop it at the end of
// the overlay tree.
const FeedPrompts = ({
  showSignInPrompt,
  setShowSignInPrompt,
  pendingAction,
  showCreditsPrompt,
  setShowCreditsPrompt,
  creditsPromptConfig,
  handleClosePlayer,
}) => {
  return (
    <>
      {/* Sign In Prompt Overlay */}
      {showSignInPrompt && (
        <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center" onClick={() => setShowSignInPrompt(false)}>
          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 max-w-sm mx-4 text-center" onClick={e => e.stopPropagation()}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r from-emerald-500/20 to-cyan-500/20 flex items-center justify-center">
              <LogIn className="h-8 w-8 text-emerald-400" />
            </div>
            <h3 className="text-white text-xl font-bold mb-2">
              Sign In Required
            </h3>
            <p className="text-gray-400 mb-6">
              Please sign in to post a {pendingAction === 'homeChat' ? 'chat message' : 'comment'}.
            </p>
            <button
              onClick={() => {
                setShowSignInPrompt(false);
                handleClosePlayer();
                // Pop the global auth modal in Sign-In mode rather than
                // routing the user to /pricing.
                window.dispatchEvent(new CustomEvent("open-auth"));
              }}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-600 to-cyan-600 hover:from-emerald-500 hover:to-cyan-500 text-white font-semibold px-6 py-3 rounded-full transition-all"
              data-testid="signin-prompt-cta"
            >
              <LogIn className="h-5 w-5" />
              Sign In / Sign Up
            </button>
            <button
              onClick={() => setShowSignInPrompt(false)}
              className="block w-full mt-4 text-gray-500 hover:text-gray-300 text-sm"
            >
              Maybe later
            </button>
          </div>
        </div>
      )}

      {/* Credits Prompt Overlay */}
      {showCreditsPrompt && (
        <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center" onClick={() => setShowCreditsPrompt(null)}>
          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 max-w-sm mx-4 text-center" onClick={e => e.stopPropagation()}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r from-amber-500/20 to-emerald-500/20 flex items-center justify-center">
              <Coins className="h-8 w-8 text-emerald-400" />
            </div>
            <h3 className="text-white text-xl font-bold mb-2">
              Requires {creditsPromptConfig[showCreditsPrompt].amount} Credits
            </h3>
            <p className="text-gray-400 mb-6">
              {creditsPromptConfig[showCreditsPrompt].action}
            </p>
            <Link
              to="/pricing"
              onClick={() => { setShowCreditsPrompt(null); handleClosePlayer(); }}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-600 to-cyan-600 hover:from-emerald-500 hover:to-cyan-500 text-white font-semibold px-6 py-3 rounded-full transition-all"
            >
              <Coins className="h-5 w-5" />
              Get Credits
            </Link>
            <button
              onClick={() => setShowCreditsPrompt(null)}
              className="block w-full mt-4 text-gray-500 hover:text-gray-300 text-sm"
            >
              Maybe later
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FeedPrompts;
